import {TPersonalizeStates} from './parts/Personalize/hooks/types';
import {TIconType} from './types';
import {TInputTypes} from './parts/Hyperlink/hooks/types';

type TCreateTypes<T extends string> = Record<Uppercase<T>, T>;

// SideBar constants
export const typeComponents = {
    PERSONALIZE: 'personalize',
    IMAGE: 'image',
    HYPERLINK: 'hyperlink'
} as TCreateTypes<TIconType>;

// SideBar texts
export const hyperlinkType = {
    TEXT: 'text',
    URL: 'url'
} as TCreateTypes<TInputTypes>;

export const initialStates: TPersonalizeStates = {choose: '', tree: null};
